/* Decode responsive replacements before swapping the visible image. */
const auraCardImageRequests = new WeakMap();
async function auraResponsiveCardImage(image, source, deferUntilNear = false) {
  const request = {}; auraCardImageRequests.set(image, request);
  if (deferUntilNear && 'IntersectionObserver' in window && image.getBoundingClientRect().top > innerHeight + 700) {
    await new Promise(resolve => { const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); resolve(); }
    }, {rootMargin:'700px 0px'}); observer.observe(image); });
  }
  if (!image.isConnected || auraCardImageRequests.get(image) !== request) return false;
  const url = new URL(source, location.origin), candidate = new Image();
  candidate.decoding = 'async'; candidate.loading = 'eager';
  candidate.sizes = image.sizes || '(max-width: 749px) 46vw, (max-width: 989px) 30vw, 25vw';
  const ready = new Promise(resolve => { candidate.onload = () => resolve(true); candidate.onerror = () => resolve(false); });
  if (url.pathname.includes('/cdn/shop/')) {
    const widthURL = width => { const next = new URL(url); next.searchParams.set('width', width); return next.href; };
    candidate.srcset = [180,360,540,720,960,1080,1280].map(width => widthURL(width)+' '+width+'w').join(', ');
    candidate.src = widthURL(540);
  } else candidate.src = source;
  if (!(await ready)) return false;
  try { await candidate.decode(); } catch (_) {}
  if (!image.isConnected || !candidate.naturalWidth || auraCardImageRequests.get(image) !== request) return false;
  image.decoding = 'async'; image.sizes = candidate.sizes;
  if (candidate.srcset) image.srcset = candidate.srcset; else image.removeAttribute('srcset');
  image.src = candidate.src;
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches) image.animate([{opacity:.82},{opacity:1}],{duration:160,easing:'ease-out'});
  return true;
}

/* Select cart recommendations before colour previews or carousel initialization. */
(() => {
  document.querySelectorAll('[data-aura-cart-recommendation-limit]').forEach(slider => {
    if (slider.dataset.auraRecommendationsReady) return;
    const track = slider.querySelector('.product-grid');
    if (!track) return;
    const pool = [...track.children].filter(item => item.matches('li'));
    track.querySelectorAll('template[data-aura-cart-candidate]').forEach(template => {
      const item = template.content.querySelector('li');
      if (item) pool.push(item.cloneNode(true));
      template.remove();
    });
    const identify = item => {
      const link = item.querySelector('a[href*="/products/"]');
      return link ? new URL(link.href, location.origin).pathname : '';
    };
    const unique = new Map();
    pool.forEach(item => { const id = identify(item); if (id && !unique.has(id)) unique.set(id, item); });
    const candidates = [...unique.values()];
    const limit = Math.max(1, Number(slider.dataset.auraCartRecommendationLimit) || 4);
    const key = 'aura-cart-recommendations:' + (slider.closest('.shopify-section')?.id || 'cart');
    let previous = [];
    try { previous = JSON.parse(sessionStorage.getItem(key) || '[]'); } catch (_) {}
    if (!Array.isArray(previous)) previous = [];
    for (let i = candidates.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [candidates[i], candidates[j]] = [candidates[j], candidates[i]];
    }
    const fresh = candidates.filter(item => !previous.includes(identify(item)));
    const seen = candidates.filter(item => previous.includes(identify(item)));
    const chosen = [...fresh, ...seen].slice(0, limit);
    if (chosen.length > 1 && identify(chosen[0]) === previous[0]) chosen.push(chosen.shift());
    pool.forEach(item => {
      item.querySelectorAll('link[rel="stylesheet"]').forEach(link => {
        if (![...document.head.querySelectorAll('link[rel="stylesheet"]')].some(existing => existing.href === link.href)) document.head.append(link);
      });
      if (!chosen.includes(item)) item.remove();
    });
    chosen.forEach(item => track.append(item));
    try { sessionStorage.setItem(key, JSON.stringify(chosen.map(identify))); } catch (_) {}
    slider.dataset.auraRecommendationsReady = 'true';
  });
})();

/* AuraReiment product-card color swatches */
(() => {
  if (window.__auraCardSwatches) return;
  window.__auraCardSwatches = true;

  const style = document.createElement('style');
  style.textContent =
    '.card-wrapper.card-swatches-selected:hover .media.media--hover-effect>img:first-child:not(:only-child){opacity:1!important}' +
    '.card-wrapper.card-swatches-selected .media.media--hover-effect>img+img{opacity:0!important}';
  document.head.appendChild(style);

  document.addEventListener('click', async (event) => {
    const toggle = event.target.closest?.('[data-card-swatch-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      const card = toggle.closest('.card-wrapper');
      if (!card) return;
      const expanded = toggle.getAttribute('aria-expanded') !== 'true';
      card.querySelectorAll('.card-color-swatch--extra').forEach((item) => {
        item.style.display = expanded ? 'inline-block' : 'none';
      });
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.textContent = expanded ? 'Show less' : toggle.dataset.moreLabel;
      return;
    }

    const swatch = event.target.closest?.('[data-card-swatch]');
    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();

    const card = swatch.closest('.card-wrapper');
    if (!card) return;

    const image = card.querySelector('.card__media img');
    if (image && swatch.dataset.image && !(await auraResponsiveCardImage(image, swatch.dataset.image))) return;
    card.classList.add('card-swatches-selected');
    card.querySelectorAll('[data-card-swatch]').forEach((item) => {
      item.setAttribute('aria-pressed', 'false');
      item.style.outline = 'none';
    });

    swatch.setAttribute('aria-pressed', 'true');
    swatch.style.outline = '2px solid rgb(var(--color-foreground))';
    swatch.style.outlineOffset = '2px';

    if (image && swatch.dataset.image) {
      image.alt = swatch.dataset.imageAlt || (card.querySelector('.card__heading')?.textContent.trim() || image.alt.replace(/ —.*$/, '')) + ' — ' + swatch.dataset.auraSwatchName;
    }

    if (swatch.dataset.variantId) {
      card.querySelectorAll('[data-product-url]').forEach(button => { const url = new URL(button.dataset.productUrl, location.origin); url.searchParams.set('variant', swatch.dataset.variantId); button.dataset.productUrl = url.href; });
      card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', swatch.dataset.variantId);
        link.href = url.toString();
      });
    }
  });
})();
/* Rotate listing previews only; product forms and cart line items remain authoritative. */
(() => {
  const processed = new WeakSet(), choices = new Map();
  const selector = '.product-card-wrapper, .aura-featured-wheel__item, .ar-drops__card';
  function currentColourFilters() { return [...new URLSearchParams(location.search)].filter(([key]) => /^filter\.v\.option\.colou?r$/i.test(key)).map(([,value]) => value.toLowerCase()); }
  async function apply(root) {
    if (processed.has(root)) return;
    const reveal = () => root.setAttribute('data-aura-preview-ready', '');
    const wheel = root.matches('.aura-featured-wheel__item');
    const drop = root.matches('.ar-drops__card');
    const scope = (wheel || drop) ? root.querySelector('template[data-aura-colour-options]')?.content : root;
    if (!scope) { reveal(); return; }
    const options = [...scope.querySelectorAll('[data-card-swatch]')].filter(s => s.dataset.available === 'true' && s.dataset.image && s.dataset.variantId);
    if (!options.length) { reveal(); return; }
    const link = wheel ? root : root.querySelector('a[href*="/products/"]');
    if (!link) { reveal(); return; }
    processed.add(root);
    const product = new URL(link.href, location.origin).pathname;
    const key = 'aura-preview-colour:' + product;
    let previous = '';
    try { previous = sessionStorage.getItem(key) || ''; } catch (_) {}
    const colourFilters = currentColourFilters();
    const filtered = options.filter(s => colourFilters.includes((s.dataset.auraSwatchName || '').toLowerCase()));
    // A colour filter takes precedence over variety.
    if (colourFilters.length && !filtered.length) { reveal(); return; }
    const eligible = filtered.length ? filtered : options;
    let chosen = eligible.find(s => s.dataset.variantId === choices.get(product));
    if (!chosen) {
      const different = eligible.filter(s => s.dataset.variantId !== previous);
      const pool = different.length ? different : eligible;
      const vivid = pool.filter(s => !/^(white|off[ -]?white|ivory|cream)$/i.test(s.dataset.auraSwatchName || ''));
      const varied = vivid.length && Math.random() < .8 ? vivid : pool;
      chosen = varied[Math.floor(Math.random() * varied.length)];
      choices.set(product, chosen.dataset.variantId);
      try { sessionStorage.setItem(key, chosen.dataset.variantId); } catch (_) {}
    }
    const image = wheel ? root.querySelector('img') : root.querySelector(drop ? '.ar-drops__image' : '.card__media img');
    if (!drop) reveal();
    if (image) {
      if (!(await auraResponsiveCardImage(image, chosen.dataset.image, true))) { reveal(); return; }
      if (drop) {
        const second = root.querySelector('.ar-drops__second');
        if (second) {
          second.style.display = 'none';
          if (chosen.dataset.secondImage && await auraResponsiveCardImage(second, chosen.dataset.secondImage)) second.style.removeProperty('display');
        }
        const heart = root.querySelector('[data-ar-wish]');
        if (heart) heart.dataset.image = image.currentSrc || image.src;
        root.dataset.auraPreviewColour = chosen.dataset.auraSwatchName;
      }
      image.alt = chosen.dataset.imageAlt || (wheel ? root.dataset.title : root.querySelector('.card__heading')?.textContent.trim() || image.alt.replace(/ —.*$/, '')) + ' — ' + chosen.dataset.auraSwatchName;
    }
    const links = wheel ? [root] : root.querySelectorAll('a[href*="/products/"]');
    links.forEach(a => { const url = new URL(a.href, location.origin); url.searchParams.set('variant', chosen.dataset.variantId); a.href = url.href; });
    if (drop) reveal();
    if (wheel) {
      if (root.getAttribute('aria-current') === 'true') root.closest('[data-aura-featured-wheel]')?.querySelector('.aura-featured-wheel__detail a')?.setAttribute('href', root.href);
    } else if (!drop) {
      root.classList.add('card-swatches-selected');
      scope.querySelectorAll('[data-card-swatch]').forEach(s => { s.setAttribute('aria-pressed', String(s === chosen)); s.style.outline = s === chosen ? '2px solid rgb(var(--color-foreground))' : 'none'; });
      chosen.style.outlineOffset = '2px';
      if (chosen.classList.contains('card-color-swatch--extra')) {
        const lastVisible = [...scope.querySelectorAll('[data-card-swatch]:not(.card-color-swatch--extra)')].pop();
        if (lastVisible) { lastVisible.classList.add('card-color-swatch--extra'); lastVisible.style.display = 'none'; }
        chosen.classList.remove('card-color-swatch--extra'); chosen.style.display = 'inline-block';
      }
      root.querySelectorAll('[data-product-url]').forEach(button => { const url = new URL(button.dataset.productUrl, location.origin); url.searchParams.set('variant', chosen.dataset.variantId); button.dataset.productUrl = url.href; });
    }
  }
  function scan(node) {
    if (node.nodeType !== 1 && node.nodeType !== 9) return;
    if (node.matches?.(selector)) apply(node);
    node.querySelectorAll(selector).forEach(apply);
  }
  scan(document);
  window.__auraPreviewBooted = true;
  const main = document.getElementById('MainContent');
  if (main) new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(scan))).observe(main, {childList:true,subtree:true});
})();

/* Cart recommendations reveal on approach; browsing and buttons keep their native behaviour. */
(() => {
  if (!document.querySelector('#MainContent cart-items') || !('IntersectionObserver' in window)) return;
  const cards = document.querySelectorAll('#MainContent .product-card-wrapper');
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) { entry.target.classList.add('aura-cart-suggestion-visible'); observer.unobserve(entry.target); }
  }), {threshold:.12});
  cards.forEach((card, i) => { card.style.setProperty('--aura-suggestion-delay', (i % 4) * 65 + 'ms'); observer.observe(card); });
})();

/* Cart-only spotlight rail: native touch scrolling with perspective depth. */
(() => {
 if (!document.querySelector('#MainContent cart-items')) return;
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 document.querySelectorAll('#MainContent .collection slider-component').forEach(slider=>{
  const track=slider.querySelector('.product-grid');
  if(!track||slider.dataset.auraRailReady)return;
  const items=[...track.children].filter(item=>item.querySelector('.product-card-wrapper'));
  if(items.length<2)return;
  slider.dataset.auraRailReady='true';slider.classList.add('aura-cart-rail');track.classList.add('aura-cart-rail__track');track.tabIndex=0;
  track.setAttribute('aria-label','Bestsellers spotlight. Swipe or use left and right arrow keys.');
  const controls=document.createElement('div');controls.className='aura-cart-rail__controls';
  controls.innerHTML='<button type="button" aria-label="Previous bestseller">←</button><span aria-live="polite" aria-atomic="true"></span><button type="button" aria-label="Next bestseller">→</button>';slider.append(controls);
  const hint=document.createElement('p');hint.className='aura-cart-rail__hint';hint.textContent='Swipe to explore · Choose your colour · Find your next Aura';slider.append(hint);
  const [previous,next]=controls.querySelectorAll('button'),counter=controls.querySelector('span');let active=-1,frame=0;
  const paint=()=>{frame=0;let closest=0,distance=Infinity;
   items.forEach((item,i)=>{const delta=item.offsetLeft+item.offsetWidth/2-track.scrollLeft-track.clientWidth/2;const normalized=Math.max(-1,Math.min(1,delta/Math.max(1,item.offsetWidth))),depth=Math.abs(normalized);
    item.style.setProperty('--aura-rail-scale',reduced.matches?'1':String(1-depth*.1));item.style.setProperty('--aura-rail-turn',reduced.matches?'0deg':normalized*-10+'deg');item.style.setProperty('--aura-rail-lift',reduced.matches?'0px':depth*16+'px');item.style.setProperty('--aura-rail-opacity',String(1-depth*.25));if(Math.abs(delta)<distance){distance=Math.abs(delta);closest=i;}});
   if(active!==closest){active=closest;items.forEach((item,i)=>item.classList.toggle('aura-cart-rail__front',i===active));counter.textContent=(active+1)+' / '+items.length;previous.disabled=active===0;next.disabled=active===items.length-1;}};
  const schedule=()=>{if(!frame)frame=requestAnimationFrame(paint);};
  const go=direction=>{const item=items[Math.max(0,Math.min(items.length-1,active+direction))];track.scrollTo({left:item.offsetLeft-(track.clientWidth-item.offsetWidth)/2,behavior:reduced.matches?'instant':'smooth'});};
  previous.addEventListener('click',()=>go(-1));next.addEventListener('click',()=>go(1));track.addEventListener('scroll',schedule,{passive:true});
  track.addEventListener('keydown',event=>{if(event.target!==track||!['ArrowLeft','ArrowRight'].includes(event.key))return;event.preventDefault();go(event.key==='ArrowRight'?1:-1);});
  const resize=new ResizeObserver(schedule);resize.observe(track);reduced.addEventListener('change',schedule);
  slider.closest('.shopify-section')?.addEventListener('shopify:section:unload',()=>{resize.disconnect();cancelAnimationFrame(frame);reduced.removeEventListener('change',schedule);},{once:true});paint();
 });
})();
